import * as actionTypes from '../actions/actionTypes'

const initialState = {
  pagination: { total: 0, to: 0, lastPage: 1, from: 0, currentPage: 1, perPage: 10 },
  records: [],
  company: [],
  resultType: [],
  filterThresholdGroup: [],
  filterLoading: false,
  selectedRecord: null,
  loadingStates: []
}

const fetchThresholdGroupStart = (state, action) => {
  return { ...state, loading: true, loadingStates: [...state.loadingStates, 'record'] }
}

const fetchThresholdGroupSuccess = (state, action) => {
  let { pagination, records } = action

  records = records.map(res => {
    let data = res
    return {
      ...data,
      company_name: data?.company?.company_name
    }
  })
  return {
    ...state,
    records: records,
    loading: false,
    loadingStates: state.loadingStates.filter(item => item !== 'record'),
    pagination: pagination
  }
}

const fetchThresholdGroupFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    loadingStates: state.loadingStates.filter(item => item !== 'record'),
    message: action.errorMessage
  }
}

const fetchCompanyStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchCompanySuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    company: action.data
  }
}

const fetchCompanyFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}

const fetchResultTypeStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchResultTypeSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    resultType: action.data
  }
}

const fetchResultTypeFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}

const fetchThresholdGroupFilterThresholdGroupStart = (state, action) => {
  return { ...state, filterLoading: true }
}

const fetchThresholdGroupFilterThresholdGroupSuccess = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    filterThresholdGroup: action.data
  }
}

const fetchThresholdGroupFilterThresholdGroupFailed = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    message: action.errorMessage
  }
}

const createThresholdGroupStart = (state, action) => {
  return { ...state, loading: true }
}

const createThresholdGroupSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const createThresholdGroupFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const updateThresholdGroupStart = (state, action) => {
  return { ...state, loading: true }
}

const updateThresholdGroupSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const updateThresholdGroupFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const deleteThresholdGroupStart = (state, action) => {
  return { ...state, loading: true }
}

const deleteThresholdGroupSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const deleteThresholdGroupFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const fetchThresholdGroupByIdSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    selectedRecord: action.recordData,
    loadingStates: state.loadingStates.filter(item => item !== 'record')
  }
}

const clearSelectedThresholdGroupRecord = (state, action) => {
  return {
    ...state,
    selectedRecord: { thresholds: [] },
    success: false
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_THRESHOLD_GROUP_START:
      return fetchThresholdGroupStart(state, action)
    case actionTypes.FETCH_THRESHOLD_GROUP_SUCCESS:
      return fetchThresholdGroupSuccess(state, action)
    case actionTypes.FETCH_THRESHOLD_GROUP_FAILED:
      return fetchThresholdGroupFailed(state, action)
    case actionTypes.CREATE_THRESHOLD_GROUP_START:
      return createThresholdGroupStart(state, action)
    case actionTypes.CREATE_THRESHOLD_GROUP_SUCCESS:
      return createThresholdGroupSuccess(state, action)
    case actionTypes.CREATE_THRESHOLD_GROUP_FAILED:
      return createThresholdGroupFailed(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_START:
      return fetchCompanyStart(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_SUCCESS:
      return fetchCompanySuccess(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_FAILED:
      return fetchCompanyFailed(state, action)
    case actionTypes.FETCH_RESULT_TYPE_OPTIONS_START:
      return fetchResultTypeStart(state, action)
    case actionTypes.FETCH_RESULT_TYPE_OPTIONS_SUCCESS:
      return fetchResultTypeSuccess(state, action)
    case actionTypes.FETCH_RESULT_TYPE_OPTIONS_FAILED:
      return fetchResultTypeFailed(state, action)
    case actionTypes.FETCH_THRESHOLD_GROUP_FILTER_THRESHOLD_GROUP_START:
      return fetchThresholdGroupFilterThresholdGroupStart(state, action)
    case actionTypes.FETCH_THRESHOLD_GROUP_FILTER_THRESHOLD_GROUP_SUCCESS:
      return fetchThresholdGroupFilterThresholdGroupSuccess(state, action)
    case actionTypes.FETCH_THRESHOLD_GROUP_FILTER_THRESHOLD_GROUP_FAILED:
      return fetchThresholdGroupFilterThresholdGroupFailed(state, action)
    case actionTypes.UPDATE_THRESHOLD_GROUP_START:
      return updateThresholdGroupStart(state, action)
    case actionTypes.UPDATE_THRESHOLD_GROUP_SUCCESS:
      return updateThresholdGroupSuccess(state, action)
    case actionTypes.UPDATE_THRESHOLD_GROUP_FAILED:
      return updateThresholdGroupFailed(state, action)
    case actionTypes.DELETE_THRESHOLD_GROUP_START:
      return deleteThresholdGroupStart(state, action)
    case actionTypes.DELETE_THRESHOLD_GROUP_SUCCESS:
      return deleteThresholdGroupSuccess(state, action)
    case actionTypes.DELETE_THRESHOLD_GROUP_FAILED:
      return deleteThresholdGroupFailed(state, action)
    case actionTypes.FETCH_THRESHOLD_GROUP_BY_ID_SUCCESS:
      return fetchThresholdGroupByIdSuccess(state, action)
    case actionTypes.CLEAR_SELECTED_THRESHOLD_GROUP_RECORD:
      return clearSelectedThresholdGroupRecord(state, action)
    case actionTypes.SIGNOUT_SUCCESS:
    case actionTypes.SIGNOUT_FAILED:
      return { ...initialState }
    default:
      return state
  }
}

export default reducer
